<div class="container order-tracking">
  <!--   *ngIf="orderTrackingResponse; else loading" -->
  <div class="row">
    <!-- TAB Link on the left - START -->
    <div class="tab col-lg-3 col-md-3 col-sm-12">
      <button
        class="tablinks"
        id="defaultOpen"
        #defaultOpen
        (click)="openTab($event, 'categoryOne', categoryOne)"
      >
        <em class="material-icons custom-margin-right-icon">assignment</em>
        {{ "orderTracking.orderSummryBtn" | cxTranslate }}
      </button>
      <button
        class="tablinks"
        (click)="openTab($event, 'categoryTwo', categoryTwo)"
      >
        <em class="material-icons custom-margin-right-icon">description</em>
        {{ "orderTracking.associateDocBtn" | cxTranslate }}
      </button>
      <button
        class="tablinks"
        (click)="openTab($event, 'categoryThree', categoryThree)"
      >
        <em class="material-icons custom-margin-right-icon">rate_review</em>
        {{ "orderTracking.orderEnquiryBtn" | cxTranslate }}
      </button>
      <button
        class="tablinks"
        (click)="openTab($event, 'categoryFour', categoryFour)"
      >
        <em class="icons line-item custom-margin-right-icon"></em>
        <!-- <em class="material-icons custom-margin-right-icon">category</em> -->
        {{ "orderTracking.lineItemBtn" | cxTranslate }} ({{fullResponse?.lineData?.length}})
      </button>
    </div>
    <!-- TAB Link on the left - END -->
    <!-- TAB contents on the right - START-->
    <div
      id="categoryOne"
      #categoryOne
      class="tabcontent col-lg-9 col-md-9 col-sm-12"
    >
      <div class="row"  *ngIf="orderTrackingResponse && displayContentsOnLoad; else loading">
        <div class="col-lg-12 col-md-12 col-sm-12">
          <div
            class="tabcontent-display-line-section-heading title-text title-padding-bottom"
          >
            <em class="material-icons custom-margin-right-icon">assignment</em>
            {{ "orderTracking.orderSummryBtn" | cxTranslate }}
            <div class="heading-extras row">
              <span class="info-item cust-info-header"
                >{{ "orderTracking.poHeader" | cxTranslate }}:<strong class="cust-info-content">
                  {{ orderTrackingResponse[0]?.customerPO }}</strong
                >
              </span>
              <span class="info-item cust-info-header"
                >{{ "orderTracking.poDateHeader" | cxTranslate }}:<strong class="cust-info-content">
                  {{
                    orderTrackingResponse[0]?.purchaseOrderDate | date: "d MMM, y"
                  }}</strong
                >
              </span>
              <span class="info-item cust-info-header">
                {{ "orderTracking.orderStatusHeader" | cxTranslate }} :
                <span
                  [ngStyle]="{
                    'background-color': fetchOrderStatusColor(
                      orderTrackingResponse[0]?.orderStatus
                    )
                  }"
                  class="status-label in-progress"
                >
                  {{ fetchOrderStatus(orderTrackingResponse[0]?.orderStatus) }}</span
                >
              </span>
            </div>
          </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 bottom-space top-space">
          <vs-status-bubble
            [statusType]="setBubbleOrderStatus()"
            [currentStatusIndex]="
              setBubbleOrderStatusId(orderTrackingResponse[0]?.orderStatus)
            "
            [isBlocked]="checkWhetherBlocked(orderTrackingResponse[0]?.orderStatus)"
          ></vs-status-bubble>
        </div>
              <div class="col-lg-12 col-md-12 col-sm-12 blocked-notification-message"
                *ngIf="checkWhetherBlocked(orderTrackingResponse[0]?.orderStatus)">
                <div class="d-flex mt-1">
                <em class="material-icons "><span class="material-icons-outlined notification-icon">notification_important</span></em>
                  <span class="obsolete-text">{{"orderTracking.blockedOrderText" |
                    cxTranslate}}<br>{{"orderTracking.blockedOrderTextSub" | cxTranslate}}
                  </span>
                </div>
                <ul class="message-text">
                  <li *ngFor="let orderInq of getBlockText(orderTrackingResponse[0]?.blkText); let i = index">{{orderInq}}</li>
                </ul>
              </div>

        <div class="col-lg-8 col-md-8 col-sm-12 customer-info bottom-space">
          <div class="cust-info-header">
            {{ "orderTracking.cstmrAccntHdr" | cxTranslate }} :
            <strong class="cust-info-content">{{
              orderTrackingResponse[0]?.soldToName
            }}</strong>
          </div>
          <div class="cust-info-header">
            {{ "orderTracking.infoTermHdr" | cxTranslate }} :
            <strong class="cust-info-content">{{
              orderTrackingResponse[0]?.incoterm
            }}</strong>
          </div>
          <div class="cust-info-header">
            {{ "orderTracking.netPriceHeader" | cxTranslate }} :
            <strong class="cust-info-content">{{orderTrackingResponse[0]?.currency }}{{  getNetPrice(orderTrackingResponse[0]?.totNetPrice,orderTrackingResponse[0]?.currency ) }}</strong>
          </div>
          <div class="cust-info-header">
            {{ "orderTracking.cstmrAccNoHdr" | cxTranslate }} :
            <strong class="cust-info-content">{{
              orderTrackingResponse[0]?.soldToUid
            }}</strong>
          </div>
          <div class="cust-info-header">
            {{ "orderTracking.orderShiptypeHdr" | cxTranslate }} :
            <strong class="cust-info-content">{{
              orderTrackingResponse[0]?.courier
            }}</strong>
            <!-- orderTrackingResponse[0]?.shippingMethod -->
          </div>
          <div class="cust-info-header">
            {{ "orderTracking.shipmentType" | cxTranslate }} :
            <strong class="cust-info-content">{{
              orderTrackingResponse[0]?.shippingMethod
            }}</strong>
            <!-- orderTrackingResponse[0]?.shippingMethod -->
          </div>
          <div class="cust-info-header">
            {{ "orderTracking.orderTypeHdr" | cxTranslate }} :
            <strong class="cust-info-content">{{
              orderTrackingResponse[0]?.orderType
            }}</strong>
          </div>
          <!-- <div class="cust-info-header">
            {{ "orderTracking.paymentTermHdr" | cxTranslate }} :
            <strong class="cust-info-content">{{
              orderTrackingResponse[0]?.paymentTerm
            }}</strong>
          </div> -->
          <div class="cust-info-header">
            {{ "orderTracking.createdByHdr" | cxTranslate }} :
            <strong class="cust-info-content">{{
              orderTrackingResponse[0]?.createdBy
            }}</strong>
          </div>
          <div class="cust-info-header">
            {{ "orderTracking.salesAreaHdr" | cxTranslate }} :
            <strong class="cust-info-content">{{
              orderTrackingResponse[0]?.salesArea
            }}</strong>
          </div>
          <div class="cust-info-header">
            {{ "orderTracking.bookDateHdr" | cxTranslate }} :
            <strong class="cust-info-content">{{
              orderTrackingResponse[0]?.orderDate
            }}</strong>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12 btn-sec">
          <a class="download-txt" (click)="downloadPDF()">
            <i class="icons download"></i>
            {{ "orderTracking.downloadPDF" | cxTranslate }}
          </a>

            <button
              class="btn vs-primary-btn repeat-order"
              *ngIf="(checkUserEnabled(accessibility.SELLABILITYFLAG) | async)"
              (click)="repeatThisOrder()"
              [disabled]="displaySearchLoader"

            >
          <div
            *ngIf="displaySearchLoader"
            class="availability-spinner cx-spinner"
          >
            <cx-spinner></cx-spinner>
          </div>

              <span class="material-icons">add_shopping_cart</span>
              {{ "orderTracking.repeatOrder" | cxTranslate }}</button
            >

        </div>
      </div>
      <div class="row" *ngIf="displayContentsOnLoad">
        <div class="col-md-12">
          <h5 class="tabcontent-display-line-section-heading">
            {{ "orderTracking.addressDetail" | cxTranslate }}
          </h5>
        </div>
        <div class="col-md-12">
          <vs-address-details
            [soldToAddress]="orderTrackingResponse[0]?.soldToAddress"
            [shipToAddress]="orderTrackingResponse[0]?.shippingAddress"
            [endUserAddress]="orderTrackingResponse[0]?.endUserAddress"
          ></vs-address-details>
        </div>
      </div>
      <div class="row custom-last-child-margin" *ngIf="displayContentsOnLoad">
        <div class="col-md-12">
          <div class="tabcontent-display-line-section-heading">
            {{ "orderTracking.lineItemBtn" | cxTranslate }}
            <span
              class="expand-txt"
              (click)="expandAll = !expandAll"
              [ngClass]="{ expanded: expandAll }"
            >
              <em class="material-icons keyboard-arrow">keyboard_arrow_down</em>
              <span *ngIf="!expandAll">{{ "orderTracking.expandAllBtn" | cxTranslate }}</span>
              <span *ngIf="expandAll">{{ "orderTracking.collapseAllBtn" | cxTranslate }}</span>
            </span>
          </div>
        </div>
        <div class="col-md-12">
          <vs-line-items
            [expandAll]="expandAll"
            [orderTrackingResponse]="orderTrackingResponse"
          ></vs-line-items>
        </div>
      </div>
    </div>
    <div id="categoryTwo" #categoryTwo class="tabcontent" >
      <div *ngIf="displayContentsOnLoad; else loading">
        <vs-associated-documents
        [orderNo]="orderIdToBeTracked"
      ></vs-associated-documents>
      </div>
    </div>
    <div id="categoryThree" #categoryThree class="tabcontent pageBtnMargin">
      <div class="row custom-last-child-margin" *ngIf="displayContentsOnLoad; else loading">
        <div class="col-lg-12 col-md-12 col-sm-12">
          <h5
            class="tabcontent-display-line-section-heading title-text title-padding-bottom"
          >
            <em class="material-icons custom-margin-right-icon">rate_review</em>
            {{ "orderTracking.orderEnquiryBtn" | cxTranslate }}
          </h5>
        </div>
        <div
          class="col-lg-12 col-md-12 col-sm-12 margintop"
          *ngIf="displayFormHideMessage"
        >
          <form [formGroup]="inquiryForm" (submit)="submitInquiry(orderTrackingResponse[0]?.customerPO, orderTrackingResponse[0]?.purchaseOrderDate)">
            <span class="contact-txt"
              >{{ "orderTracking.contactUs" | cxTranslate }}</span
            >
            <div class="inquiry-dropdown">
              <label
                ><div class="inquiry-label-txt required">
                  <span class="star"></span>{{ "orderTracking.typeOfEnquiry" | cxTranslate }}
                </div>
              </label>
              <div class="dropdown">
                <ng-select
                  [ngClass]="
                    inquiryFormSubmitted && f.orderInquiry?.errors?.required
                      ? 'error-select'
                      : ''
                  "
                  formControlName="orderInquiry"
                  id="orderInquiry"
                  class="inquiry-type"
                  [searchable]="false"
                  [clearable]="false"
                  placeholder='{{ "orderTracking.selectPlaceholder" | cxTranslate }}'
                >
                  <ng-option
                    *ngFor="let orderInq of orderInquiries; let i = index"
                    [value]="orderInq.code"
                  >
                    {{ orderInq.name }}
                  </ng-option>
                </ng-select>
                <label
                  *ngIf="
                    inquiryFormSubmitted && f.orderInquiry?.errors?.required
                  "
                  class="error"
                >
                {{ "orderTracking.selectInquiry" | cxTranslate }}
                </label>
              </div>
            </div>

            <div class="form-control-wrapper current-item-block">
              <label>
                <div class="inquiry-label-txt required">
                  <span class="star"></span>
                  {{ "orderTracking.description" | cxTranslate }}
                </div>
                <textarea
                  type="text"
                  class="form-control textareadesc"
                  [ngClass]="
                    inquiryFormSubmitted && f.inquiryDesc?.errors?.required
                      ? 'error'
                      : ''
                  "
                  name="inquiryDesc"
                  formControlName="inquiryDesc"
                  maxlength="255"
                ></textarea>
                <label
                  *ngIf="
                    inquiryFormSubmitted && f.inquiryDesc?.errors?.required
                  "
                  class="error"
                >
                {{ "orderTracking.enterDescription" | cxTranslate }}
                </label>
                <label class="char-limit char-limit-count"
            >  {{ "orderTracking.charactersLeft" | cxTranslate }} : {{ 255 - inquiryForm.value.inquiryDesc?.length }}</label
          >
              </label>
            </div>
            <div class="right-sec">
              <button type="submit" class="btn vs-primary-btn submit-btn">
                {{ "orderTracking.submitBtn" | cxTranslate }}
              </button>
            </div>
          </form>
        </div>

        <div
          class="col-lg-12 col-md-12 col-sm-12"
          *ngIf="!displayFormHideMessage"
        >
          <div class="success-txt-message">
            <em class="material-icons">check_circle</em>
            <span class="submittal-text">
              <strong class="part1">&nbsp;{{ "orderTracking.success" | cxTranslate }}</strong>&nbsp; <span class="part2">{{ "orderTracking.enquirySubmit" | cxTranslate }}</span></span
            >
          </div>
        </div>
      </div>
    </div>
    <div id="categoryFour" #categoryFour class="tabcontent">
      <div class="row custom-last-child-margin"  *ngIf="displayContentsOnLoad; else loading">
        <div class="col-md-12">
          <div
            class="tabcontent-display-line-section-heading title-text title-padding-bottom"
          >
            <em class="icons line-item-title-img custom-margin-right-icon"></em>
            {{ "orderTracking.lineItemBtn" | cxTranslate }}
            <span
              class="expand-txt-section"
              (click)="expandAll = !expandAll"
              [ngClass]="{ expanded: expandAll }"
            >
              <em class="material-icons keyboard-arrow">keyboard_arrow_down</em>
              <span *ngIf="!expandAll">{{ "orderTracking.expandAllBtn" | cxTranslate }}</span>
              <span *ngIf="expandAll">{{ "orderTracking.collapseAllBtn" | cxTranslate }}</span>
            </span>
          </div>
        </div>
        <div class="col-md-12">
          <vs-line-items
            [expandAll]="expandAll"
            [orderTrackingResponse]="orderTrackingResponse"
          ></vs-line-items>
        </div>
      </div>
    </div>

    <!-- TAB contents on the right - END-->
  </div>
</div>

<!-- PAGINATION symbol to load on screen - START -->
<ng-template #loading class="spinner-class">
  <div class="cx-spinner">
    <cx-spinner></cx-spinner>
  </div>
</ng-template>
<!-- PAGINATION symbol to load on screen - END -->
